import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { StepType } from '@/modules/base/components/modal/upgrade-modal-v2/hooks/useUpgradeSteps'
import { ShoppingCartItems } from '@/modules/moduleSubscription/types/ShoppingCart'
import { Subscription } from '@/modules/moduleSubscription/types/module'

export const STEPS: Record<string, StepType> = {
  SUBSCRIPTION_MAIN: 'main',
  SUBSCRIPTION_DOCUMENT: 'document',
  SUBSCRIPTION_STAFF: 'staff',
  EXTENSIONS: 'extensions',
  BILLING: 'billingForm',
  SUCCESS: 'success',
}

export const selectionSteps = [
  STEPS.SUBSCRIPTION_MAIN,
  STEPS.SUBSCRIPTION_DOCUMENT,
  STEPS.SUBSCRIPTION_STAFF,
]

export interface UploadStateInterface {
  activeStep: StepType,
  activeStepIndex: number,
  stepsInOrder: StepType[],
  completedSteps: Array<number>,
  subscriptionTypes: Subscription[],
  productsInCart: ShoppingCartItems
  showModules: boolean
  orderCompleted: boolean
}

const initialState: UploadStateInterface = {
  activeStep: null,
  activeStepIndex: 0,
  stepsInOrder: [],
  completedSteps: [],
  subscriptionTypes: [],
  showModules: false,
  productsInCart: {},
  orderCompleted: false,
}

const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    setActiveStep(state, action: PayloadAction<StepType>) {
      state.activeStep = action.payload
      state.activeStepIndex = state.stepsInOrder?.length ? state.stepsInOrder.indexOf(action.payload) : 0
    },
    setStepsInOrder(state, action: PayloadAction<StepType[]>) {
      state.stepsInOrder = action.payload
    },
    setCompletedSteps(state, action: PayloadAction<Array<number>>) {
      state.completedSteps = action.payload
    },
    setSubscriptionTypes(state, action: PayloadAction<Subscription[]>) {
      state.subscriptionTypes = action.payload
    },
    setShowModules(state, action: PayloadAction<boolean>) {
      state.showModules = action.payload
    },
    setProductsInCart(state, action: PayloadAction<ShoppingCartItems>) {
      state.productsInCart = action.payload
    },
    setOrderCompleted(state, action: PayloadAction<boolean>) {
      state.orderCompleted = action.payload
    },
    resetState() {
      return { ...initialState }
    },
  },
})

export const {
  setActiveStep,
  setStepsInOrder,
  setCompletedSteps,
  setSubscriptionTypes,
  setShowModules,
  setProductsInCart,
  setOrderCompleted,
  resetState,
} = uploadSlice.actions
export default uploadSlice.reducer
